import { useState, useEffect } from 'react';

export const useWeightSimulation = (isConnected) => {
	const [weight, setWeight] = useState(0);

	useEffect(() => {
		if (!isConnected) {
			setWeight(0);
			return;
		}

		// Simulate realistic weight fluctuations
		const interval = setInterval(() => {
			// Generate weight between 10-60 tons (10000-60000 kg)
			const baseWeight = Math.floor(Math.random() * 50000) + 10000;

			// Add small fluctuations to simulate real scale behavior
			const fluctuation = (Math.random() - 0.5) * 100; // ±50kg fluctuation
			const finalWeight = Math.max(0, Math.floor(baseWeight + fluctuation));

			setWeight(finalWeight);
		}, 5000); // Update every 2 seconds

		return () => clearInterval(interval);
	}, [isConnected]);

	return weight;
};